module.exports = __webpack_public_path__ + "manageLink.9add22da.jpg";